import {ApolloClient, InMemoryCache, gql} from '@apollo/client'

const client = new ApolloClient({
  uri: 'https://waterlogic-de.myshopify.com/api/2024-01/graphql.json',
  cache: new InMemoryCache(),
  headers: {
    'X-Shopify-Storefront-Access-Token': '93a39e3e071c529bc8c8dc15c9cb5a5f',
  },
})

const GET_PRODUCT_BY_HANDLE = gql`
  query getProductByHandle($handle: String!) {
    product(handle: $handle) {
      id
      title
      handle
      description
      descriptionHtml
      vendor
      images(first: 10) {
        edges {
          node {
            id
            url
            altText
            width
            height
          }
        }
      }
      options {
        id
        name
        values
      }
      variants(first: 100) {
        edges {
          node {
            id
            title
            sku
            availableForSale
            price {
              amount
              currencyCode
            }
            compareAtPrice {
              amount
              currencyCode
            }
            selectedOptions {
              name
              value
            }
            image {
              id
              url
              altText
              width
              height
            }
          }
        }
      }
      collections(first: 10) {
        edges {
          node {
            id
            title
            handle
          }
        }
      }
    }
  }
`

export class ProductApiService {
  async getProductByHandle(handle: string) {
    try {
      const {data} = await client.query({
        query: GET_PRODUCT_BY_HANDLE,
        variables: {handle},
      })

      if (!data.product) {
        throw new Error('Product not found')
      }

      return this.transformProductData(data.product)
    } catch (error) {
      console.error('Error fetching product:', error)
      throw error
    }
  }

  private transformProductData(productData: any) {
    return {
      id: productData.id,
      title: productData.title,
      handle: productData.handle,
      description: productData.description,
      descriptionHtml: productData.descriptionHtml,
      vendor: productData.vendor,
      images: productData.images.edges.map((edge: any) => ({
        id: edge.node.id,
        src: edge.node.url,
        altText: edge.node.altText,
        width: edge.node.width,
        height: edge.node.height,
      })),
      options: productData.options,
      variants: productData.variants.edges.map((edge: any) => ({
        id: edge.node.id,
        title: edge.node.title,
        sku: edge.node.sku,
        available: edge.node.availableForSale,
        price: {
          amount: edge.node.price.amount,
          currencyCode: edge.node.price.currencyCode,
        },
        priceV2: {
          amount: edge.node.price.amount,
          currencyCode: edge.node.price.currencyCode,
        },
        compareAtPrice: edge.node.compareAtPrice
          ? {
              amount: edge.node.compareAtPrice.amount,
              currencyCode: edge.node.compareAtPrice.currencyCode,
            }
          : undefined,
        image: edge.node.image
          ? {
              src: edge.node.image.url,
              altText: edge.node.image.altText,
              width: edge.node.image.width,
              height: edge.node.image.height,
            }
          : undefined,
        optionValues: edge.node.selectedOptions,
      })),
      collections: productData.collections.edges.map((edge: any) => ({
        id: edge.node.id,
        title: edge.node.title,
        handle: edge.node.handle,
      })),
    }
  }
}

export const productApiService = new ProductApiService()
